import { collectionEngineV1 } from '../apis';
const reqAPI = collectionEngineV1('/debt-register');
export const rkiReport = (id, caseId, claim, personName) => reqAPI('POST', `/rki/${id}`, {
    body: { caseId, claim, personName },
});
export const rkiDelete = (id, caseId, rkiReferenceId, reason) => reqAPI('DELETE', `/rki/${id}?caseId=${caseId}&reason=${reason}&rkiReferenceId=${rkiReferenceId}`);
export const rkiStatus = (id, caseId, rkiReferenceId) => reqAPI('GET', `/rki/${id}/${caseId}/${rkiReferenceId}`);
export const rkiMoveToOpen = (id, caseId, rkiReferenceId, claim) => reqAPI('POST', `/rki/move-to-open/${id}`, {
    body: { caseId, rkiReferenceId, claim },
});
export const rkiConclude = (id, caseId, rkiReferenceId) => reqAPI('POST', `/rki/conclude/${id}`, {
    body: { caseId, rkiReferenceId },
});
export const rkiError = (id, caseId, rkiReferenceId, error) => reqAPI('POST', `/rki/error/${id}`, {
    body: { caseId, error, rkiReferenceId },
});
//# sourceMappingURL=debt-register.js.map